import { Box } from "@mui/material"
import React from "react"
import { CallSpinner } from "./CallChrome/CallSpinner"

export function Loader() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100dvh",
        width: "100%",
        backgroundColor: "var(--color-background-bg-page)",
      }}
    >
      <CallSpinner />
    </Box>
  )
}
